module.exports = __webpack_public_path__ + "static/media/health.c9617c20.svg";